export default "__VITE_ASSET__C9X$TvLH__"